import { render, staticRenderFns } from "./EntryInfo.vue?vue&type=template&id=280c6fd6&scoped=true"
import script from "./EntryInfo.vue?vue&type=script&lang=js"
export * from "./EntryInfo.vue?vue&type=script&lang=js"
import style0 from "./EntryInfo.vue?vue&type=style&index=0&id=280c6fd6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280c6fd6",
  null
  
)

export default component.exports